<div class="ds-notification-warning ds-notification-error" *ngIf="conflictingPluginsList">
  <div>
    <i class="db-icon db-icon-ds-info-bg"></i>
    <p>
      <b>{{'text_somePluginsConflictingWithBooster' | dbText: {companyName: companyName} }}</b>
      <span><span>
            <a dbWpLink [adminLink]="website?.adminBoosterSettingsPage" [websiteId]="websiteId" target="_blank" rel="noopener"
               *ngIf="website?.connectedFrom !== 'speed_optimizer'">{{'text_goToWPAdmin' | dbText}}</a>
            <a [href]="website?.adminBoosterSettingsPage" target="_blank" rel="noopener" *ngIf="website?.connectedFrom === 'speed_optimizer'">{{'text_goToWPAdmin' | dbText}}</a>
          </span> {{'text_andDeactivateThesePlugins' | dbText}}<br/>
          {{'text_proceedingWithoutDeactivationCanReduce' | dbText: {companyName: companyName} }}<br/>
          {{'text_plugins' | dbText}}: <span class="db-plugin-names">{{conflictingPluginsList}}</span></span>
    </p>
  </div>
</div>
<div class="ds-notification-warning ds-notification-warning-cache"
     *ngIf="!conflictingPluginsList && cacheStatus?.cacheDate && optimizeStatus?.cachingDate && +cacheStatus?.cacheDate !== +optimizeStatus?.cachingDate && !website?.domain_hash && !!cacheStatus?.cacheEnabled && !!cacheEnabled">
  <div>
    <i class="db-icon db-icon-ds-info-bg"></i>
    <p>
      <b>{{'text_cacheCannotCleared' | dbText}}</b>
      <span> {{'text_websiteOptimizedButCacheClearFailed' | dbText}}<br>
            {{'text_clearCacheManuallyAndReanalyze' | dbText}} <a (click)="reanalyze()">{{'text_reanalyze' | dbText}}</a> {{'text_theScore' | dbText}}.</span><br/>
      <span class="migrate mt12" *ngIf="!userSubscription?.trialBoosterClient && !userSubscription?.boosterProClient && !userSubscription?.boosterBetaClient">{{'text_toSolveIssueAutomatically' | dbText}} <a (click)="migrate()">{{'text_migrateYourWebsite' | dbText}}</a> {{'text_toAutomatedHosting' | dbText: {companyName: companyName} }}.</span>
    </p>
  </div>
</div>
<div class="ds-notification-warning" *ngIf="disableOptions">
  <div class="db-icon-wrapper mt4 mr8">
    <i class="db-icon db-icon-ds-info-bg red mr4"></i>
    <p *ngIf="!!website?.domain_hash"><b class="mr5">{{'text_updateBoosterToAccessAdvancedSettings' | dbText: {companyName: companyName} }}</b> {{'text_boostWebsiteScoreAndResolveIssues' | dbText}} <a class="underline" (click)="updateBoosterPlugin()">{{'text_updateNow' | dbText}}</a></p>
    <p *ngIf="!website?.domain_hash"><b class="mr5">{{'text_updateBoosterToAccessAdvancedSettings' | dbText: {companyName: companyName} }}</b><span>{{'text_boostWebsiteScoreAndResolveIssues' | dbText}}</span></p>
  </div>
</div>
<div class="ds-notification-warning ds-notification-warning-webp"
     *ngIf="!conflictingPluginsList && !!webpStatus && !!webpStatus?.hosting && !webpStatus?.webpDeliveryWorking
     && (!webpStatus?.webpStatus || (!!webpStatus?.webpStatus && !webpStatus?.webpDeliveryWorking)) && !website?.domain_hash
     && ((hasCacheStatus && hasOptimizeStatus && cacheStatus && optimizeStatus && cacheStatus?.cacheDate && optimizeStatus?.cachingDate && cacheStatus?.cacheDate === optimizeStatus?.cachingDate) || cacheStatus?.cacheEnabled)">
  <div>
    <i class="db-icon db-icon-ds-info-bg"></i>
    <p>
      <b>{{'text_webpFormatNotEnabled' | dbText}}</b>
      <span>{{'text_serverPreventingWebpConversion' | dbText}} <a class='semibold'(click)="webpInstructions()">{{'text_followTheseInstructions' | dbText}}</a> {{'text_toEnableItManually' | dbText}}.</span><br/>
      <span *ngIf="!userSubscription?.trialBoosterClient && !userSubscription?.boosterProClient && !userSubscription?.boosterBetaClient">{{'text_toSolveIssueAutomatically' | dbText}} <a (click)="migrate()">{{'text_migrateYourWebsite' | dbText}}</a> {{'text_toAutomatedHosting' | dbText: {companyName: companyName} }}.</span>
    </p>
  </div>
  <span class="ds-notification-close" (click)="closeWarning($event)">
    <i class="db-icon db-icon-ds-close"></i>
  </span>
</div>
